import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from '~/redux/connect';
import {getAppPage, isAuthenticated} from "~/stateGetter";
//import get from 'lodash/get';
//import classNames from 'classnames';
//import css from './css.css';
import pages from '~/ui/Pages/pages';
import get from 'lodash/get';
import identify from "~/identify";
// import ModelPage from '~/ui/Pages/ModelPage/ModelPage';
// import ConnectedUpdateTestContainer from "~/ui/ModelDataManager/TestContainer";
// import ModelTreeDataManager from "~/ui/ModelDataManager/ModelTreeDataManager";

export class PageContainer extends Component {
    static propTypes = {};

    render() {
        let Page = get(pages, this.props.appPage, pages[identify.APP_PAGE_NOTFOUND]);
        return <Page />;
    }
}

const RXPageContainer = connect(
    (state) => {
        return {
            isAuthenticated: isAuthenticated(state),
            appPage: getAppPage(state)
        }
    },
    (dispatch) => ({}),
    (state, dispatchers, props) => {
        if(!state.isAuthenticated) {
            return { appPage: 'auth' }
        }

        return state;
    }
)(PageContainer);

export default RXPageContainer;